import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const STATS = [
  { value: "1200+", label: "Savol" },
  { value: "61", label: "Bilet" },
  { value: "42", label: "Mavzu" },
  { value: "100%", label: "Bepul" },
];

const FEATURES = [
  {
    emoji: "📚",
    title: "Mavzular bo'yicha",
    desc: "Har bir mavzuni alohida o'rganing, zaif joylarni mustahkamlang",
    color: "#3B82F6",
    bg: "rgba(59,130,246,.08)",
    border: "rgba(59,130,246,.2)",
  },
  {
    emoji: "🎫",
    title: "Biletlar",
    desc: "Barcha 61 ta rasmiy biletni yechib chiqing",
    color: "#22C55E",
    bg: "rgba(34,197,94,.08)",
    border: "rgba(34,197,94,.2)",
  },
  {
    emoji: "⚡",
    title: "Marafon rejimi",
    desc: "To'g'ri javob berganda davom etadi, xato qilsang hayot kamayadi",
    color: "#F59E0B",
    bg: "rgba(245,158,11,.08)",
    border: "rgba(245,158,11,.2)",
  },
  {
    emoji: "🎯",
    title: "Imtihon rejimi",
    desc: "Real imtihon sharoitida mashq qiling — taymer va ball tizimi bilan",
    color: "#EF4444",
    bg: "rgba(239,68,68,.08)",
    border: "rgba(239,68,68,.2)",
  },
  {
    emoji: "❌",
    title: "Xatolar ustida ishlash",
    desc: "Xato qilgan savollaringiz saqlanadi, qaytib mashq qiling",
    color: "#8B5CF6",
    bg: "rgba(139,92,246,.08)",
    border: "rgba(139,92,246,.2)",
  },
  {
    emoji: "🪧",
    title: "Yo'l belgilari",
    desc: "Barcha yo'l belgilari rasm va savol bilan — vizual o'rganish",
    color: "#06B6D4",
    bg: "rgba(6,182,212,.08)",
    border: "rgba(6,182,212,.2)",
  },
];

const TelegramIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8l-1.68 7.92c-.12.56-.46.7-.94.44l-2.6-1.92-1.26 1.2c-.14.14-.26.26-.52.26l.18-2.62 4.72-4.26c.2-.18-.04-.28-.32-.1L7.6 14.96l-2.56-.8c-.56-.18-.58-.56.12-.82l10.04-3.86c.46-.18.86.1.44.32z"
      fill="#229ED9"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
    <defs>
      <linearGradient id="ig" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#F58529" />
        <stop offset="50%" stopColor="#DD2A7B" />
        <stop offset="100%" stopColor="#8134AF" />
      </linearGradient>
    </defs>
    <rect x="2" y="2" width="20" height="20" rx="5" fill="url(#ig)" />
    <circle
      cx="12"
      cy="12"
      r="4"
      stroke="white"
      strokeWidth="1.8"
      fill="none"
    />
    <circle cx="17.5" cy="6.5" r="1.2" fill="white" />
  </svg>
);

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const isMobile = windowWidth <= 768;

  const containerPadding = isMobile ? "0 16px" : "0 24px";
  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0A0E1A",
        color: "#E2E8F0",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        overflowX: "hidden",
      }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800;900&display=swap');
        @keyframes fadeUp { from { opacity:0; transform:translateY(24px); } to { opacity:1; transform:translateY(0); } }
        @keyframes float { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-10px); } }
        @keyframes pulse { 0%,100% { opacity:.4; } 50% { opacity:.8; } }
        @keyframes spin { to { transform:rotate(360deg); } }
        @keyframes shimmer { 0%{background-position:-200% 0} 100%{background-position:200% 0} }
        .fade-up { animation: fadeUp .6s ease forwards; }
        .s1{animation-delay:.1s;opacity:0} .s2{animation-delay:.2s;opacity:0}
        .s3{animation-delay:.3s;opacity:0} .s4{animation-delay:.4s;opacity:0}
        .feat-card:hover { transform: translateY(-4px); border-color: var(--hc) !important; }
        .feat-card { transition: all .25s ease; }
        .btn-main:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(59,130,246,.45) !important; }
        .btn-main { transition: all .2s ease; }
        .btn-yellow:hover { transform: translateY(-2px); box-shadow: 0 12px 40px rgba(245,192,0,.3) !important; }
        .btn-yellow { transition: all .2s ease; }
        .btn-sec:hover { background: rgba(255,255,255,.08) !important; }
        .btn-sec { transition: all .2s ease; }
        .social-btn:hover { transform: translateY(-3px); }
        .social-btn { transition: all .2s ease; }
        .video-card:hover { transform: translateY(-3px); border-color: rgba(245,192,0,.4) !important; }
        .video-card { transition: all .2s ease; }
        .teacher-glow { animation: pulse 3s ease infinite; }
      `}</style>

      {/* ── NAVBAR ── */}
      <nav
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          background: scrollY > 40 ? "rgba(10,14,26,.97)" : "transparent",
          backdropFilter: scrollY > 40 ? "blur(16px)" : "none",
          borderBottom:
            scrollY > 40 ? "1px solid rgba(255,255,255,.06)" : "none",
          transition: "all .3s ease",
          padding: containerPadding,
          minHeight: isMobile ? 68 : 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: isMobile ? 10 : 16,
        }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div
            style={{
              width: 36,
              height: 36,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            <img
              src="/logo.png"
              alt="AvtoMind"
              style={{ width: 36, height: 36, objectFit: "contain" }}
            />
          </div>
          <span
            style={{
              color: "#fff",
              fontWeight: 800,
              fontSize: isMobile ? 14 : 16,
              whiteSpace: "nowrap",
            }}>
            AvtoMind
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {/* Social icons navbar */}
          <a
            href="https://t.me/pravaTest_2026"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 8,
              background: "rgba(34,157,217,.1)",
              border: "1px solid rgba(34,157,217,.2)",
              textDecoration: "none",
            }}
            className="social-btn">
            <TelegramIcon />
          </a>
          <a
            href="https://instagram.com/avtomind.uz"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 8,
              background: "rgba(221,42,123,.1)",
              border: "1px solid rgba(221,42,123,.2)",
              textDecoration: "none",
            }}
            className="social-btn">
            <InstagramIcon />
          </a>

          <button
            onClick={() => navigate("/auth")}
            className="btn-sec"
            style={{
              padding: "8px 18px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,.12)",
              background: "transparent",
              color: "#CBD5E1",
              fontWeight: 600,
              fontSize: 13,
              cursor: "pointer",
              fontFamily: "inherit",
            }}>
            Kirish
          </button>
          <button
            onClick={() => navigate("/auth")}
            className="btn-main"
            style={{
              padding: "8px 18px",
              borderRadius: 10,
              border: "none",
              background: "#3B82F6",
              color: "#fff",
              fontWeight: 700,
              fontSize: 13,
              cursor: "pointer",
              fontFamily: "inherit",
              boxShadow: "0 4px 16px rgba(59,130,246,.3)",
            }}>
            Boshlash →
          </button>
        </div>
      </nav>

      {/* ── HERO ── */}
      <div
        ref={heroRef}
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "80px 24px 60px",
          position: "relative",
        }}>
        <div
          style={{
            position: "absolute",
            top: "20%",
            left: "50%",
            transform: "translateX(-50%)",
            width: 600,
            height: 400,
            background:
              "radial-gradient(ellipse,rgba(59,130,246,.12),transparent)",
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "10%",
            left: "15%",
            width: 200,
            height: 200,
            background:
              "radial-gradient(ellipse,rgba(34,197,94,.06),transparent)",
            pointerEvents: "none",
            animation: "pulse 4s ease infinite",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: "30%",
            right: "10%",
            width: 150,
            height: 150,
            background:
              "radial-gradient(ellipse,rgba(245,192,0,.06),transparent)",
            pointerEvents: "none",
            animation: "pulse 5s ease infinite 1s",
          }}
        />

        <div
          className="fade-up s1"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 14px",
            borderRadius: 99,
            background: "rgba(59,130,246,.1)",
            border: "1px solid rgba(59,130,246,.25)",
            color: "#60A5FA",
            fontSize: 12,
            fontWeight: 700,
            marginBottom: 24,
          }}>
          <span
            style={{
              width: 6,
              height: 6,
              borderRadius: "50%",
              background: "#22C55E",
              animation: "pulse 2s ease infinite",
              display: "inline-block",
            }}
          />
          2026-yil yangilangan testlar
        </div>

        <h1
          className="fade-up s2"
          style={{
            fontSize: "clamp(32px,6vw,64px)",
            fontWeight: 900,
            lineHeight: 1.1,
            marginBottom: 20,
            color: "#fff",
            maxWidth: 700,
          }}>
          Haydovchilik imtihoniga{" "}
          <span
            style={{
              background: "linear-gradient(135deg,#3B82F6,#60A5FA)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}>
            tayyor bo'ling
          </span>
        </h1>

        <p
          className="fade-up s3"
          style={{
            color: "#64748B",
            fontSize: "clamp(14px,2vw,18px)",
            maxWidth: 480,
            lineHeight: 1.7,
            marginBottom: 36,
          }}>
          1200+ savol, 61 rasmiy bilet va marafon rejimi bilan imtihonga
          mukammal tayyorlaning. Bepul.
        </p>

        <div
          className="fade-up s4"
          style={{
            display: "flex",
            gap: 12,
            flexWrap: "wrap",
            justifyContent: "center",
          }}>
          <button
            onClick={() => navigate("/auth")}
            className="btn-main"
            style={{
              padding: "14px 32px",
              borderRadius: 14,
              border: "none",
              background: "#3B82F6",
              color: "#fff",
              fontWeight: 800,
              fontSize: 15,
              cursor: "pointer",
              fontFamily: "inherit",
              boxShadow: "0 8px 24px rgba(59,130,246,.35)",
            }}>
            🚀 Testni boshlash
          </button>
          <button
            onClick={() => navigate("/auth")}
            className="btn-sec"
            style={{
              padding: "14px 32px",
              borderRadius: 14,
              border: "1px solid rgba(255,255,255,.1)",
              background: "rgba(255,255,255,.04)",
              color: "#CBD5E1",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              fontFamily: "inherit",
            }}>
            Ro'yxatdan o'tish
          </button>
        </div>

        <div
          className="fade-up"
          style={{
            display: "flex",
            gap: "clamp(24px,5vw,60px)",
            marginTop: 60,
            flexWrap: "wrap",
            justifyContent: "center",
            animationDelay: ".5s",
            opacity: 0,
          }}>
          {STATS.map((s) => (
            <div key={s.label} style={{ textAlign: "center" }}>
              <p
                style={{
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: "clamp(22px,4vw,32px)",
                  lineHeight: 1,
                }}>
                {s.value}
              </p>
              <p
                style={{
                  color: "#475569",
                  fontSize: 13,
                  marginTop: 4,
                  fontWeight: 600,
                }}>
                {s.label}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ── TEACHER SECTION ── */}
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "80px 24px" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 40,
            alignItems: "center",
          }}>
          {/* Left — text */}
          <div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 12px",
                borderRadius: 99,
                background: "rgba(245,192,0,.1)",
                border: "1px solid rgba(245,192,0,.25)",
                color: "#F5C000",
                fontSize: 12,
                fontWeight: 700,
                marginBottom: 20,
              }}>
              ⭐ Mutaxassis nazorati
            </div>
            <h2
              style={{
                color: "#fff",
                fontWeight: 900,
                fontSize: "clamp(24px,3vw,36px)",
                lineHeight: 1.2,
                marginBottom: 16,
              }}>
              Tajribali ustoz{" "}
              <span style={{ color: "#F5C000" }}>nazoratida</span>
            </h2>
            <p
              style={{
                color: "#64748B",
                fontSize: 15,
                lineHeight: 1.7,
                marginBottom: 24,
              }}>
              Bu platform 5 yildan ortiq tajribaga ega haydovchilik nazariy
              imtihon ustozi tomonidan tekshirilgan va tasdiqlangan. Har bir
              savol, har bir bilet — professional ko'zdan kechirilgan.
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { icon: "✅", text: "5+ yillik tajriba" },
                { icon: "📋", text: "Barcha 61 bilet tekshirilgan" },
                { icon: "🔄", text: "Testlar muntazam yangilanadi" },
                { icon: "🎯", text: "Real imtihon savollariga mos" },
              ].map((item, i) => (
                <div
                  key={i}
                  style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontSize: 18 }}>{item.icon}</span>
                  <span
                    style={{ color: "#CBD5E1", fontSize: 14, fontWeight: 600 }}>
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — teacher card */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                background:
                  "linear-gradient(135deg,rgba(245,192,0,.08),rgba(59,130,246,.08))",
                border: "1px solid rgba(245,192,0,.2)",
                borderRadius: 24,
                padding: 32,
                textAlign: "center",
                maxWidth: 280,
                width: "100%",
                position: "relative",
              }}>
              {/* Glow */}
              <div
                className="teacher-glow"
                style={{
                  position: "absolute",
                  top: -20,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: 120,
                  height: 120,
                  borderRadius: "50%",
                  background:
                    "radial-gradient(circle,rgba(245,192,0,.15),transparent)",
                  pointerEvents: "none",
                }}
              />

              {/* Avatar */}
              <div
                style={{
                  width: 90,
                  height: 90,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg,#F5C000,#D4A800)",
                  margin: "0 auto 16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 36,
                  fontWeight: 900,
                  color: "#111",
                  boxShadow: "0 8px 32px rgba(245,192,0,.3)",
                }}>
                👨‍🏫
              </div>

              <h3
                style={{
                  color: "#fff",
                  fontWeight: 900,
                  fontSize: 18,
                  marginBottom: 6,
                }}>
                Ustoz
              </h3>
              <p
                style={{
                  color: "#F5C000",
                  fontSize: 13,
                  fontWeight: 700,
                  marginBottom: 12,
                }}>
                Nazariy imtihon mutaxassisi
              </p>
              <p style={{ color: "#64748B", fontSize: 12, lineHeight: 1.6 }}>
                5+ yil davomida yuzlab talabalarni imtihondan o'tkazgan
                tajribali ustoz
              </p>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 16,
                  marginTop: 20,
                }}>
                {[
                  { label: "Yil tajriba", value: "5+" },
                  { label: "Talaba", value: "500+" },
                ].map((s, i) => (
                  <div key={i} style={{ textAlign: "center" }}>
                    <div
                      style={{
                        color: "#F5C000",
                        fontWeight: 900,
                        fontSize: 20,
                      }}>
                      {s.value}
                    </div>
                    <div
                      style={{
                        color: "#475569",
                        fontSize: 10,
                        fontWeight: 600,
                      }}>
                      {s.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── VIDEO DARSLIK SECTION ── */}
      <div
        style={{
          background: "rgba(245,192,0,.03)",
          borderTop: "1px solid rgba(245,192,0,.08)",
          borderBottom: "1px solid rgba(245,192,0,.08)",
          padding: "80px 24px",
        }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: 48 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "5px 12px",
                borderRadius: 99,
                background: "rgba(239,68,68,.1)",
                border: "1px solid rgba(239,68,68,.25)",
                color: "#F87171",
                fontSize: 12,
                fontWeight: 700,
                marginBottom: 16,
              }}>
              🎬 Tez orada
            </div>
            <h2
              style={{
                color: "#fff",
                fontWeight: 900,
                fontSize: "clamp(24px,4vw,36px)",
                marginBottom: 12,
              }}>
              Video darsliklar
            </h2>
            <p
              style={{
                color: "#475569",
                fontSize: 15,
                maxWidth: 480,
                margin: "0 auto",
              }}>
              15 kun ichida barcha 61 bilet uchun video darsliklar qo'shiladi.
              Har bir biletni ustoz bilan birga yechamiz!
            </p>
          </div>

          {/* Progress bar — 15 kun */}
          <div style={{ maxWidth: 500, margin: "0 auto 48px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 8,
              }}>
              <span style={{ color: "#64748B", fontSize: 13, fontWeight: 600 }}>
                Tayyorgarlik jarayoni
              </span>
              <span style={{ color: "#F5C000", fontSize: 13, fontWeight: 800 }}>
                Tez orada!
              </span>
            </div>
            <div
              style={{
                height: 8,
                background: "rgba(255,255,255,.05)",
                borderRadius: 99,
                overflow: "hidden",
              }}>
              <div
                style={{
                  height: "100%",
                  width: "65%",
                  background: "linear-gradient(90deg,#F5C000,#D4A800)",
                  borderRadius: 99,
                  backgroundSize: "200% 100%",
                  animation: "shimmer 2s linear infinite",
                }}
              />
            </div>
            <p
              style={{
                color: "#334155",
                fontSize: 11,
                marginTop: 8,
                textAlign: "center",
              }}>
              61 biletdan 40 tasi tayyorlanmoqda...
            </p>
          </div>

          {/* Video cards preview */}
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))",
              gap: 16,
            }}>
            {[
              {
                num: 1,
                title: "Bilet 1 — Yo'l harakati asoslari",
                time: "12 min",
                ready: true,
              },
              {
                num: 2,
                title: "Bilet 2 — Yo'l belgilari",
                time: "15 min",
                ready: true,
              },
              {
                num: 3,
                title: "Bilet 3 — Chorrahalar",
                time: "18 min",
                ready: false,
              },
              {
                num: 4,
                title: "Bilet 4 — Ustuvorlik qoidalari",
                time: "14 min",
                ready: false,
              },
            ].map((v, i) => (
              <div
                key={i}
                className="video-card"
                style={{
                  background: "#111827",
                  border: `1px solid ${v.ready ? "rgba(34,197,94,.2)" : "rgba(255,255,255,.06)"}`,
                  borderRadius: 16,
                  overflow: "hidden",
                  cursor: v.ready ? "pointer" : "default",
                  opacity: v.ready ? 1 : 0.6,
                }}>
                {/* Thumbnail */}
                <div
                  style={{
                    height: 120,
                    background: `linear-gradient(135deg,${v.ready ? "rgba(34,197,94,.1)" : "rgba(255,255,255,.03)"},rgba(10,14,26,.8))`,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: "50%",
                      background:
                        v.ready ? "rgba(34,197,94,.2)" : "rgba(255,255,255,.1)",
                      border: `2px solid ${v.ready ? "#22C55E" : "rgba(255,255,255,.1)"}`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}>
                    <span style={{ fontSize: 18 }}>
                      {v.ready ? "▶️" : "🔒"}
                    </span>
                  </div>
                  <div
                    style={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      background:
                        v.ready ?
                          "rgba(34,197,94,.15)"
                        : "rgba(255,255,255,.08)",
                      border: `1px solid ${v.ready ? "rgba(34,197,94,.3)" : "rgba(255,255,255,.1)"}`,
                      borderRadius: 6,
                      padding: "3px 8px",
                      fontSize: 10,
                      fontWeight: 700,
                      color: v.ready ? "#22C55E" : "#64748B",
                    }}>
                    {v.ready ? "TAYYOR" : "TASHKENT"}
                  </div>
                </div>
                <div style={{ padding: "12px 14px" }}>
                  <p
                    style={{
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 13,
                      marginBottom: 6,
                    }}>
                    {v.title}
                  </p>
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ fontSize: 12 }}>⏱</span>
                    <span style={{ color: "#64748B", fontSize: 12 }}>
                      {v.time}
                    </span>
                    <span
                      style={{
                        marginLeft: "auto",
                        color: v.ready ? "#22C55E" : "#64748B",
                        fontSize: 11,
                        fontWeight: 700,
                      }}>
                      Bilet #{v.num}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ textAlign: "center", marginTop: 32 }}>
            <button
              onClick={() => navigate("/auth")}
              className="btn-yellow"
              style={{
                padding: "13px 32px",
                borderRadius: 12,
                border: "1px solid rgba(245,192,0,.3)",
                background: "rgba(245,192,0,.08)",
                color: "#F5C000",
                fontWeight: 800,
                fontSize: 14,
                cursor: "pointer",
                fontFamily: "inherit",
              }}>
              📺 Barcha darsliklarni ko'rish →
            </button>
          </div>
        </div>
      </div>

      {/* ── FEATURES ── */}
      <div
        style={{ maxWidth: 960, margin: "0 auto", padding: "80px 24px 60px" }}>
        <div style={{ textAlign: "center", marginBottom: 48 }}>
          <h2
            style={{
              color: "#fff",
              fontWeight: 900,
              fontSize: "clamp(24px,4vw,36px)",
              marginBottom: 12,
            }}>
            Hamma narsa bir joyda
          </h2>
          <p style={{ color: "#475569", fontSize: 15 }}>
            Imtihon o'tish uchun kerakli barcha vositalar
          </p>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))",
            gap: 16,
          }}>
          {FEATURES.map((f) => (
            <div
              key={f.title}
              className="feat-card"
              style={
                {
                  background: f.bg,
                  border: `1px solid ${f.border}`,
                  borderRadius: 20,
                  padding: 24,
                  cursor: "pointer",
                  "--hc": f.color,
                } as React.CSSProperties
              }
              onClick={() => navigate("/auth")}>
              <div
                style={{
                  fontSize: 32,
                  marginBottom: 14,
                  animation: "float 3s ease infinite",
                  display: "inline-block",
                }}>
                {f.emoji}
              </div>
              <h3
                style={{
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: 16,
                  marginBottom: 8,
                }}>
                {f.title}
              </h3>
              <p style={{ color: "#64748B", fontSize: 13, lineHeight: 1.6 }}>
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* ── SOCIAL SECTION ── */}
      <div style={{ maxWidth: 960, margin: "0 auto", padding: "0 24px 80px" }}>
        <div
          style={{
            background:
              "linear-gradient(135deg,rgba(34,157,217,.08),rgba(221,42,123,.08))",
            border: "1px solid rgba(255,255,255,.06)",
            borderRadius: 24,
            padding: "40px 32px",
            textAlign: "center",
          }}>
          <h2
            style={{
              color: "#fff",
              fontWeight: 900,
              fontSize: "clamp(20px,3vw,30px)",
              marginBottom: 12,
            }}>
            Bizni kuzatib boring! 👀
          </h2>
          <p
            style={{
              color: "#64748B",
              fontSize: 14,
              marginBottom: 32,
              maxWidth: 400,
              margin: "0 auto 32px",
            }}>
            Har kuni yangi savollar, foydali maslahatlar va yangiliklar
          </p>

          <div
            style={{
              display: "flex",
              gap: 16,
              justifyContent: "center",
              flexWrap: "wrap",
            }}>
            {/* Telegram */}
            <a
              href="https://t.me/pravaTest_2026"
              target="_blank"
              rel="noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "14px 24px",
                borderRadius: 14,
                background: "rgba(34,157,217,.1)",
                border: "1px solid rgba(34,157,217,.25)",
                textDecoration: "none",
                transition: "all .2s",
              }}
              className="social-btn"
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.background =
                  "rgba(34,157,217,.18)";
                (e.currentTarget as HTMLElement).style.borderColor = "#229ED9";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.background =
                  "rgba(34,157,217,.1)";
                (e.currentTarget as HTMLElement).style.borderColor =
                  "rgba(34,157,217,.25)";
              }}>
              <TelegramIcon />
              <div style={{ textAlign: "left" }}>
                <div style={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>
                  Telegram
                </div>
                <div style={{ color: "#64748B", fontSize: 11 }}>
                  @pravaTest_2026
                </div>
              </div>
            </a>

            {/* Instagram */}
            <a
              href="https://instagram.com/avtomind.uz"
              target="_blank"
              rel="noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "14px 24px",
                borderRadius: 14,
                background: "rgba(221,42,123,.1)",
                border: "1px solid rgba(221,42,123,.25)",
                textDecoration: "none",
                transition: "all .2s",
              }}
              className="social-btn"
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.background =
                  "rgba(221,42,123,.18)";
                (e.currentTarget as HTMLElement).style.borderColor = "#DD2A7B";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.background =
                  "rgba(221,42,123,.1)";
                (e.currentTarget as HTMLElement).style.borderColor =
                  "rgba(221,42,123,.25)";
              }}>
              <InstagramIcon />
              <div style={{ textAlign: "left" }}>
                <div style={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>
                  Instagram
                </div>
                <div style={{ color: "#64748B", fontSize: 11 }}>
                  @avtomind.uz
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* ── CTA BOTTOM ── */}
      <div
        style={{
          textAlign: "center",
          padding: "60px 24px 80px",
          borderTop: "1px solid rgba(255,255,255,.06)",
        }}>
        <h2
          style={{
            color: "#fff",
            fontWeight: 900,
            fontSize: "clamp(22px,4vw,36px)",
            marginBottom: 16,
          }}>
          Hoziroq boshlang — bepul! 🎉
        </h2>
        <p
          style={{
            color: "#475569",
            fontSize: 15,
            maxWidth: 400,
            margin: "0 auto 32px",
          }}>
          Minglab o'quvchilar allaqachon imtihondan o'tdi
        </p>
        <button
          onClick={() => navigate("/auth")}
          className="btn-main"
          style={{
            padding: "16px 40px",
            borderRadius: 14,
            border: "none",
            background: "#3B82F6",
            color: "#fff",
            fontWeight: 800,
            fontSize: 16,
            cursor: "pointer",
            fontFamily: "inherit",
            boxShadow: "0 8px 32px rgba(59,130,246,.4)",
          }}>
          Ro'yxatdan o'tish →
        </button>
      </div>

      {/* ── FOOTER ── */}
      <div
        style={{
          borderTop: "1px solid rgba(255,255,255,.04)",
          padding: "24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 12,
        }}>
        <div style={{ color: "#334155", fontSize: 12, fontWeight: 600 }}>
          © 2026 AvtoMind — avtomind.uz
        </div>
        <div style={{ display: "flex", gap: 12 }}>
          <a
            href="https://t.me/pravaTest_2026"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 8,
              background: "rgba(34,157,217,.1)",
              border: "1px solid rgba(34,157,217,.15)",
              textDecoration: "none",
            }}>
            <TelegramIcon />
          </a>
          <a
            href="https://instagram.com/avtomind.uz"
            target="_blank"
            rel="noreferrer"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 32,
              height: 32,
              borderRadius: 8,
              background: "rgba(221,42,123,.1)",
              border: "1px solid rgba(221,42,123,.15)",
              textDecoration: "none",
            }}>
            <InstagramIcon />
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
